module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav-links scrolling-tabs"
  }, [_c('li', {
    staticClass: "js-pipelines-tab-all",
    class: {
      active: _vm.scope === 'all'
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.paths.allPath
    }
  }, [_vm._v("\n      All\n      "), _c('span', {
    staticClass: "badge js-totalbuilds-count"
  }, [_vm._v("\n        " + _vm._s(_vm.count.all) + "\n      ")])])]), _vm._v(" "), _c('li', {
    staticClass: "js-pipelines-tab-pending",
    class: {
      active: _vm.scope === 'pending'
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.paths.pendingPath
    }
  }, [_vm._v("\n      Pending\n      "), _c('span', {
    staticClass: "badge"
  }, [_vm._v("\n        " + _vm._s(_vm.count.pending) + "\n      ")])])]), _vm._v(" "), _c('li', {
    staticClass: "js-pipelines-tab-running",
    class: {
      active: _vm.scope === 'running'
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.paths.runningPath
    }
  }, [_vm._v("\n      Running\n      "), _c('span', {
    staticClass: "badge"
  }, [_vm._v("\n        " + _vm._s(_vm.count.running) + "\n      ")])])]), _vm._v(" "), _c('li', {
    staticClass: "js-pipelines-tab-finished",
    class: {
      active: _vm.scope === 'finished'
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.paths.finishedPath
    }
  }, [_vm._v("\n      Finished\n      "), _c('span', {
    staticClass: "badge"
  }, [_vm._v("\n        " + _vm._s(_vm.count.finished) + "\n      ")])])]), _vm._v(" "), _c('li', {
    staticClass: "js-pipelines-tab-branches",
    class: {
      active: _vm.scope === 'branches'
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.paths.branchesPath
    }
  }, [_vm._v("Branches")])]), _vm._v(" "), _c('li', {
    staticClass: "js-pipelines-tab-tags",
    class: {
      active: _vm.scope === 'tags'
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.paths.tagsPath
    }
  }, [_vm._v("Tags")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2528e465"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/navigation_tabs.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2528e465"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/navigation_tabs.vue
// module chunks = pipelines